export default __webpack_public_path__ + "static/media/handshake.dffee364.svg";